"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileImageViews = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var string_1 = require("utils/string");
var url_1 = require("utils/url");
var LazyLoad = require("vanilla-lazyload/dist/lazyload");
var ssrcontext_1 = require("ssrcontext");
var s = require("./index.scss");
var getDefaultImage = function (countryCode) {
    if (countryCode === void 0) { countryCode = isomorphismConstant_1.default.countryCode; }
    var images = {
        LITBOUKU: "https://i.ezbuy.sg/Ft8hVIYTrHQbYdGJd5xRiqmo4R9M",
        LITBMINI: "https://i.ezbuy.sg/FtLN01Ua7syH7st7xBZG1AFpjCqC"
    };
    return images[countryCode.toUpperCase()] || "https://i.ezbuy.sg/FtEqaGwu0Naah-QPPwd1J49dw6jX";
};
var defaultImage = getDefaultImage();
var isSupportLazyLoad = ssrcontext_1.runInServer() ? false : "IntersectionObserver" in window;
if (!ssrcontext_1.runInServer() && !document.lazyLoadInstance) {
    document.lazyLoadInstance = new LazyLoad({ element_selector: ".lazy" });
}
var MobileImageViews = (function (_super) {
    __extends(MobileImageViews, _super);
    function MobileImageViews() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            originSrc: _this.props.src,
            imageSrc: "",
            useOriginSrc: false
        };
        _this.updateImageSrc = function (useOrigin, props) {
            if (useOrigin === void 0) { useOrigin = false; }
            if (props === void 0) { props = _this.props; }
            var src = props.src, params = props.params, _a = props.alisize, alisize = _a === void 0 ? 0 : _a;
            if (!src) {
                return;
            }
            if (/^data:image/.test(src)) {
                _this.setState({ useOriginSrc: true, imageSrc: src });
                return;
            }
            _this.setState({
                useOriginSrc: useOrigin,
                imageSrc: useOrigin
                    ? src
                    : url_1.compatibleProtocolLessUrl(url_1.transferAlisize(url_1.compatibleWebpImage(url_1.compatibleQiniuAndGeneralImage(src, params)), alisize))
            });
        };
        _this.onImageLoad = function (event) {
            try {
                if (event.target.naturalWidth <= 1) {
                    _this.onImageFailedLoad();
                }
            }
            catch (err) { }
        };
        _this.onImageFailedLoad = function () {
            if (!_this.state.useOriginSrc) {
                _this.updateImageSrc(true);
            }
            else {
                _this.setState({ imageSrc: _this.props.placeholder || defaultImage });
            }
        };
        return _this;
    }
    MobileImageViews.getDerivedStateFromProps = function (nextProps, prevState) {
        return nextProps.src !== prevState.originSrc
            ? {
                originSrc: nextProps.src,
                imageSrc: "",
                useOriginSrc: false
            }
            : prevState;
    };
    MobileImageViews.prototype.componentDidMount = function () {
        this.updateImageSrc();
        document.lazyLoadInstance && document.lazyLoadInstance.update();
    };
    MobileImageViews.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (prevState.originSrc !== this.state.originSrc) {
            this.updateImageSrc(false, this.props);
        }
        document.lazyLoadInstance && document.lazyLoadInstance.update();
    };
    MobileImageViews.prototype.render = function () {
        var imageSrc = this.state.imageSrc;
        var _a = this.props, isLazyLoad = _a.isLazyLoad, height = _a.height, width = _a.width, className = _a.className, style = _a.style, alt = _a.alt, onClick = _a.onClick, placeholder = _a.placeholder, isPostImageToBackground = _a.isPostImageToBackground;
        var imgProps = {
            width: width,
            height: height,
            style: style,
            alt: alt,
            onClick: onClick
        };
        var placeholderImage = ssrcontext_1.runInServer()
            ? imageSrc || this.props.src
            : placeholder || defaultImage;
        if (typeof imageSrc !== "undefined" && !string_1.isEmpty(imageSrc)) {
            if (isLazyLoad && isSupportLazyLoad) {
                if (isPostImageToBackground) {
                    return (React.createElement("div", { className: s.bckImg, style: { backgroundImage: "url(" + imageSrc + ")" } },
                        React.createElement("img", __assign({}, imgProps, { className: classnames_1.default(className, "lazy"), src: placeholderImage, "data-src": imageSrc, onLoad: this.onImageLoad, onError: this.onImageFailedLoad }))));
                }
                else {
                    return (React.createElement("img", __assign({}, imgProps, { className: classnames_1.default(className, "lazy"), src: placeholderImage, "data-src": imageSrc, onLoad: this.onImageLoad, onError: this.onImageFailedLoad })));
                }
            }
            else {
                if (isPostImageToBackground) {
                    return (React.createElement("div", { className: s.bckImg, style: { backgroundImage: "url(" + imageSrc + ")" } },
                        React.createElement("img", __assign({}, imgProps, { className: className, src: imageSrc, onLoad: this.onImageLoad, onError: this.onImageFailedLoad }))));
                }
                else {
                    return (React.createElement("img", __assign({}, imgProps, { className: className, src: imageSrc, onLoad: this.onImageLoad, onError: this.onImageFailedLoad })));
                }
            }
        }
        if (isPostImageToBackground) {
            return (React.createElement("div", { className: s.bckImg, style: { backgroundImage: "url(" + placeholderImage + ")" } },
                React.createElement("img", __assign({}, imgProps, { className: className, src: placeholderImage }))));
        }
        return React.createElement("img", __assign({}, imgProps, { className: className, src: placeholderImage }));
    };
    MobileImageViews.defaultProps = {
        isLazyLoad: false,
        alisize: 0,
        isPostImageToBackground: false
    };
    return MobileImageViews;
}(React.Component));
exports.MobileImageViews = MobileImageViews;
